// extracted by mini-css-extract-plugin
module.exports = {"container":"ProductList_container__amA6o","item":"ProductList_item__1DRJj"};